import { graphql } from 'gatsby';

import GlobalHead from '../../layout/head';

import layoutTheme from '../../editorial/theme';
import Layout from '../../layout';
import AllArticlesArchiveLayout from './layout';

import type { HeadProps, PageProps } from 'gatsby';
import type { IAllArticle, IPageContext } from './types';

const AllArticlesArchiveTemplate = ({ data, pageContext, ...pageProps }: PageProps<IAllArticle, IPageContext>) => {
  return (
    <Layout
      {...pageProps}
      {...pageContext}
      showBreadcrumbs={false}
      templateName="Editorial"
      theme={layoutTheme}
    >
      <AllArticlesArchiveLayout data={data} pageContext={pageContext} />
    </Layout>
  );
};

export const query = graphql`
  query AllArticlesArchiveTemplate($skip: Int!, $limit: Int!) {
    wpCategory(slug: { regex: "/all-.*/" }) {
      id
      parentId
      name
      description
      categoryOptions {
        featuredImage {
          altText
          sizes
          sourceUrl
          srcSet
          gatsbyImage: wpGatsbyImage(width: 588, height: 392)
        }
        testimonial {
          buttons {
            url
            text
            openInNewTab
          }
          quoteText
        }
      }
      slug
      uri
      link
      count
      headlessSeo {
        canonical
        metaDesc
        metaRobotsNoindex
        metaRobotsNofollow
        title
      }
      translations {
        hreflang
        url
      }
    }

    allWpPost(
      sort: { date: DESC}
      limit: $limit
      skip: $skip
      filter: {categories: {nodes: {elemMatch: {name: {nin: ["Developer", "Uncategorized"]}}}}}
    ) {
      edges {
        node {
          title
          uri,
          link,
          date
          excerpt,
          readTime: timeToRead,
          author {
            node {
              name
              uri
              usersAuthor {
                profilePhoto {
                  altText
                  sizes
                  sourceUrl
                  srcSet
                  gatsbyImage: wpGatsbyImage(
                    height: 196
                    placeholder: BLURRED
                    width: 196
                  )
                }
              }
            }
          }
          templatesEditorial {
            cardImage {
              altText
              sizes
              sourceUrl
              srcSet
              gatsbyImage: wpGatsbyImage(
                formats: WEBP
                placeholder: BLURRED
                height: 256
                width: 384
              )
            }
            postTitle {
              shortTitle
            }
          }
        categories {
          nodes {
            name
            slug
            uri
            link
          }
        }
      }
    }
  }
}
`;

export const Head = ({
  data,
  location,
  pageContext,
}: HeadProps<IAllArticle, IPageContext>) => (
  <GlobalHead
    forceCanonicalTag={true}
    isPaginated={(pageContext && pageContext?.numberOfPages > 0)}
    pathname={location.pathname}
    seo={{
      title: data?.wpCategory.headlessSeo?.title || 'All posts | Klaviyo',
      canonical: data?.wpCategory.headlessSeo?.canonical,
      metaDesc: data?.wpCategory.headlessSeo?.metaDesc,
      metaRobotsNofollow: data?.wpCategory.headlessSeo?.metaRobotsNofollow || 'follow',
      metaRobotsNoindex: data?.wpCategory.headlessSeo?.metaRobotsNoindex || 'index',
      prevPagePath: (pageContext?.previousPagePath ? pageContext.previousPagePath : ''),
      nextPagePath: (pageContext?.nextPagePath ? pageContext.nextPagePath : ''),
    }}
    translations={data?.wpCategory?.translations}
  />
);

export default AllArticlesArchiveTemplate;
